import { render, staticRenderFns } from "./zone_form.vue?vue&type=template&id=5356a49a&"
import script from "./zone_form.vue?vue&type=script&lang=js&"
export * from "./zone_form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports